<div class="vb-spinner-box vb-spinner-box--page">
    <vb-spinner size="xl" label="Redirecting to login"></vb-spinner>
</div>
